import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { NvrContent } from "../Components/NvrContent";

const Nvr = () => {
  const seoData = getSEOData("/video-integration");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <NvrContent />
    </>
  );
};

export default Nvr;